export default __webpack_public_path__ + "static/media/fontawesome-webfont.f691f37e.woff";